"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withMouseEventsHandlers = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var ClickAction_1 = require("@wix/dealer-common/dist/src/services/ClickAction");
exports.withMouseEventsHandlers = function (Component) {
    var result = /** @class */ (function (_super) {
        tslib_1.__extends(WithMouseEventsHandlers, _super);
        function WithMouseEventsHandlers(props) {
            var _this = _super.call(this, props) || this;
            _this.onMouseEnterHandler = function () {
                _this.setState({ hover: true });
            };
            _this.onMouseLeaveHandler = function () {
                _this.setState({ hover: false });
            };
            _this.onClickHandler = function () {
                _this.clickAction.click(_this.props.element, _this.props.dealerOptions);
            };
            _this.state = { hover: false };
            var _a = _this.props, bannerContext = _a.bannerContext, locale = _a.locale, metasiteId = _a.metasiteId, bannerRoot = _a.bannerRoot, bannerPosition = _a.bannerPosition, onClick = _a.onClick, onClose = _a.onClose, biLogger = _a.biLogger;
            _this.clickAction = new ClickAction_1.ClickAction(bannerContext, locale, metasiteId, bannerRoot, bannerPosition, onClick, onClose, biLogger);
            return _this;
        }
        WithMouseEventsHandlers.prototype.render = function () {
            return (React.createElement("span", { onMouseEnter: this.onMouseEnterHandler, onMouseLeave: this.onMouseLeaveHandler, onClick: this.onClickHandler },
                React.createElement(Component, tslib_1.__assign({ hover: this.state.hover }, this.props))));
        };
        return WithMouseEventsHandlers;
    }(React.Component));
    return result;
};
//# sourceMappingURL=WithMouseEventsHandlers.js.map